import { required } from 'vuelidate/lib/validators'
import EmailTemplateParams from '@/components/configs/emails/templateparams/EmailTemplateParams.vue'

const defaultEl = {
  id: null,
  code: '',
  message: {}
};

export default {
  name: 'EmailEditTemplate',
  data () {
    return {
      editEl: defaultEl,
      loading: false,
      elname: 'templates'
    }
  },
  validations: {
    editEl: {
      code: { required },
      message: { required }
    }
  },
  components: {
    EmailTemplateParams
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.emails.' + this.elname + '.edit');
      }
      return this.$t('menu.config.emails.' + this.elname + '.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const self = this;
        this.ApiRequest.request('config/emails/edit/' + self.elname, this.ApiRequest.REQUEST_POST, { template: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
